import BaseComponent from '../BaseComponent';
import SelectorEngine from '../../utils/dom/selector-engine';
import Manipulator from '../../utils/dom/manipulator';
import EventHandler from '../../utils/dom/event-handler';

const NAME = 'DownloadBanner';
const CLICK_EVENT = 'click';
const DOWNLOAD_BANNER_WRAPPER = '.download-banner-wrapper';
const DOWNLOAD_BUTTON = '.lta-download-btn';
const DOWNLOAD_BUTTON_TEXT = '.download-button-text';
const CLOSE_BUTTON = '.lta-download-banner-close-icon';
const INPUT = '.lta-download-banner-input';
const HIDE_BANNER_FLAG = 'bannerHidden';

class DownloadBanner extends BaseComponent {
	constructor(element) {
		super(element);
		if (element) {
			this.init(element);
		}
	}

	static get NAME() {
		return NAME;
	}

	init(element) {
		if (localStorage.getItem(HIDE_BANNER_FLAG) === 'true') {
			element.classList.add('u-hidden');
			return;
		}

		this.downloadBannerWrapper = SelectorEngine.findOne(DOWNLOAD_BANNER_WRAPPER, element);
		this.downloadButton = SelectorEngine.findOne(DOWNLOAD_BUTTON, this.downloadBannerWrapper);
		this.downloadButtonText = SelectorEngine.findOne(DOWNLOAD_BUTTON_TEXT, this.downloadButton);
		this.closeButton = SelectorEngine.findOne(CLOSE_BUTTON, this.downloadBannerWrapper);
		this.input = SelectorEngine.findOne(INPUT, this.downloadBannerWrapper);

		this.iosUrl = Manipulator.getDataAttribute(this.input, 'ios-url');
		this.androidUrl = Manipulator.getDataAttribute(this.input, 'android-url');
		this.OS = this.getOS();

		if (!this.isMobile() || this.isSafari()) {
			this.downloadBannerWrapper.classList.add('u-hidden');
		} else if(localStorage.getItem(HIDE_BANNER_FLAG) !== 'true'){
			this.downloadBannerWrapper.classList.remove('u-hidden');
			this.initializeClass();
			EventHandler.on(this.downloadButton, CLICK_EVENT, () => {
				this.handleDownload();
			});
			EventHandler.on(this.closeButton, CLICK_EVENT, () => {
				this.downloadBannerWrapper.classList.add('u-hidden');
				localStorage.setItem(HIDE_BANNER_FLAG, 'true');
			});
		}
	}

	isMobile() {
		const userAgent = navigator.userAgent || navigator.vendor || window.opera;
		return /android|iPhone|iPad|iPod/i.test(userAgent);
	}

	getOS() {
		const userAgent = navigator.userAgent || navigator.vendor || window.opera;
		if (/windows phone/i.test(userAgent)) {
			return 'Windows Phone';
		}

		if (/android/i.test(userAgent)) {
			return 'android';
		}

		if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
			return 'iOS';
		}

		return 'unknown';
	}

	isApple() {
		return navigator.userAgent.indexOf("Mac") >= 0;
	}

	handleDownload() {
		if(this.isApple()) {
			window.open(this.iosUrl, '_blank');
		} else {
			window.open(this.androidUrl, '_blank');
		}
	}

	isSafari() {
		const userAgent = navigator.userAgent || navigator.vendor || window.opera;
		return /^((?!chrome|android).)*safari/i.test(userAgent);
	}

	initializeClass() {
		const isIOS = this.OS === 'iOS';
		const openButtonText = isIOS ? 'Open' : 'Download';
		const bgColor = isIOS ? 'u-bg-background-red' : 'u-bg-background-red';
		const openButtonClass = isIOS ? 'u-bg-grey-light' : 'u-bg-lta-accent-pink';
		const openButtonTextClass = isIOS ? 'u-text-lta-accent-bright-green' : 'u-text-white u-body1';

		this.downloadBannerWrapper.classList.add(bgColor);
		this.downloadButton.classList.add(openButtonClass);
		if(this.downloadButtonText) {
			this.downloadButtonText.innerHTML = openButtonText;
		}
	}
}

export default DownloadBanner;
